<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <router-view class="view"></router-view>
        </transition>
        <el-dialog :title="callTypeDisplayName" :visible.sync="isShowNewInvitationDialog" width="400px">
            <span>{{ this.getNewInvitationDialogContent() }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleRejectCall">拒绝</el-button>
                <el-button type="primary" @click="handleAccept">接听</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { getUsernameByUserid } from "./service";
let timeout;

export default {
    name: "App",

    watch: {
        isLogin: function (newIsLogin, oldIsLogin) {
            if (newIsLogin !== oldIsLogin) {
                if (newIsLogin) {
                    if (this.$router.history.current.path === "/login") {
                        this.$router.push("/");
                    }
                } else {
                    this.$router.push("/login");
                }
            }
        },
    },
    computed: mapState({
        isLogin: (state) => state.isLogin,
        loginUserInfo: (state) => state.loginUserInfo,
        callStatus: (state) => state.callStatus,
        isAccepted: (state) => state.isAccepted,
        meetingUserIdList: (state) => state.meetingUserIdList,
        muteVideoUserIdList: (state) => state.muteVideoUserIdList,
        muteAudioUserIdList: (state) => state.muteAudioUserIdList,
    }),
    async created () {
        this.initListener();
        await this.handleAutoLogin();
    },
    data () {
        return {
            isInviterCanceled: false,
            isShowNewInvitationDialog: false,
            errMseeageFlg: false,
            inviterName: "",
            callTypeDisplayName: "",
            inviteData: {},
            inviteID: "",
        };
    },
    destroyed () {
        this.removeListener();
    },
    methods: {

        handleAutoLogin: async function () { },
        initListener: function () {
            console.log(this.$trtcCalling,6666666666666)
            this.$trtcCalling.on(this.TrtcCalling.EVENT.ERROR, this.handleError);
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.INVITED,
                this.handleNewInvitationReceived
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.USER_ACCEPT,
                this.handleUserAccept
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.USER_ENTER,
                this.handleUserEnter
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.USER_LEAVE,
                this.handleUserLeave
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.REJECT,
                this.handleInviteeReject
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.LINE_BUSY,
                this.handleInviteeLineBusy
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.CALLING_CANCEL,
                this.handleInviterCancel
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.KICKED_OUT,
                this.handleKickedOut
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.CALLING_TIMEOUT,
                this.handleCallTimeout
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.NO_RESP,
                this.handleNoResponse
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.CALLING_END,
                this.handleCallEnd
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.USER_VIDEO_AVAILABLE,
                this.handleUserVideoChange
            );
            this.$trtcCalling.on(
                this.TrtcCalling.EVENT.USER_AUDIO_AVAILABLE,
                this.handleUserAudioChange
            );
        },
        removeListener: function () {
            this.$trtcCalling.off(this.TrtcCalling.EVENT.ERROR, this.handleError);
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.INVITED,
                this.handleNewInvitationReceived
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.USER_ACCEPT,
                this.handleUserAccept
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.USER_ENTER,
                this.handleUserEnter
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.USER_LEAVE,
                this.handleUserLeave
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.REJECT,
                this.handleInviteeReject
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.LINE_BUSY,
                this.handleInviteeLineBusy
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.CALLING_CANCEL,
                this.handleInviterCancel
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.KICKED_OUT,
                this.handleKickedOut
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.CALLING_TIMEOUT,
                this.handleCallTimeout
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.NO_RESP,
                this.handleNoResponse
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.CALLING_END,
                this.handleCallEnd
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.USER_VIDEO_AVAILABLE,
                this.handleUserVideoChange
            );
            this.$trtcCalling.off(
                this.TrtcCalling.EVENT.USER_AUDIO_AVAILABLE,
                this.handleUserAudioChange
            );
        },
        handleError: function (err) {
            console.log(err)
            console.log('handleError')
        },
        handleNewInvitationReceived: async function (payload) {
            console.log('handleNewInvitationReceived', 11111111)
            const { inviteID, sponsor, inviteData } = payload;
            // log(`handleNewInvitationReceived ${JSON.stringify(payload)}`);
            if (inviteData.callEnd) {
                // 最后一个人发送 invite 进行挂断
                this.$store.commit("updateCallStatus", "idle");
                return;
            }
            if (sponsor === this.loginUserInfo.userId) {
                // 邀请人是自己, 同一个账号有可能在多端登录
                return;
            }
            // 这里需要考虑忙线的情况
            if (this.callStatus === "calling" || this.callStatus === "connected") {
                await this.$trtcCalling.reject({ inviteID, isBusy: true });
                return;
            }

            const { callType } = inviteData;
            this.inviteData = inviteData;
            this.inviteID = inviteID;
            this.isInviterCanceled = false;
            this.$store.commit("updateIsInviter", false);
            this.$store.commit("updateCallStatus", "calling");
            const userName = sponsor;
            this.inviterName = userName;
            this.callTypeDisplayName =
                callType === this.TrtcCalling.CALL_TYPE.AUDIO_CALL
                    ? "语音通话"
                    : "视频通话";
            // this.isShowNewInvitationDialog = true;
        },
        getNewInvitationDialogContent: function () {
            console.log('getNewInvitationDialogContent', 22222)
            return `来自${this.inviterName}的${this.callTypeDisplayName}`;
        },
        handleRejectCall: async function () {
            console.log('handleRejectCall')
            try {
                const { callType } = this.inviteData;
                await this.$trtcCalling.reject({
                    inviteID: this.inviteID,
                    isBusy: false,
                    callType,
                });
                this.dissolveMeetingIfNeed();
            } catch (e) {
                this.dissolveMeetingIfNeed();
            }
        },

        handleAccept: function () {
            console.log('handleAccept')
            this.handleDebounce(this.handleAcceptCall(), 500);
        },

        handleDebounce: function (func, wait) {
            console.log('handleDebounce')
            let context = this;
            let args = arguments;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(context, args);
            }, wait);
        },

        handleAcceptCall: async function () {
            console.log('handleAcceptCall')
            try {
                const { callType, roomID } = this.inviteData;
                this.$store.commit("userJoinMeeting", this.loginUserInfo.userId);
                await this.$trtcCalling.accept({
                    inviteID: this.inviteID,
                    roomID,
                    callType,
                });
                this.isShowNewInvitationDialog = false;
                if (
                    callType === this.TrtcCalling.CALL_TYPE.AUDIO_CALL &&
                    this.$router.history.current.fullPath !== "/audio-call"
                ) {
                    this.$router.push("/audio-call");
                } else if (
                    callType === this.TrtcCalling.CALL_TYPE.VIDEO_CALL &&
                    this.$router.history.current.fullPath !== "/video-call"
                ) {
                    this.$router.push("/video-call");
                }
            } catch (e) {
                this.dissolveMeetingIfNeed();
            }
        },
        handleUserAccept: function (event) {
            console.log('handleUserAccept')
            this.$store.commit("userAccepted", true);
            this.$store.state.autioEle.pause();
            this.$store.state.autioEle.remove()

        },
        handleUserEnter: function ({ userID }) {
            // 建立连接
            this.$store.commit("userJoinMeeting", userID);
            if (this.callStatus === "calling") {
                console.log('calling')
                // 如果是邀请者, 则建立连接
                this.$nextTick(() => {
                    // 需要先等远程用户 id 的节点渲染到 dom 上
                    this.$store.commit("updateCallStatus", "connected");
                    // this.$store.state.autioEle.pause();

                });
            } else {
                console.log('calling-else')
                // 第n (n >= 3)个人被邀请入会, 并且他不是第 n 个人的邀请人
                this.$nextTick(() => {
                    // 需要先等远程用户 id 的节点渲染到 dom 上
                    this.$trtcCalling.startRemoteView({
                        userID: userID,
                        videoViewDomID: `video-${userID}`,
                    });
                });
            }
        },
        handleUserLeave: function ({ userID }) {
            console.log('handleUserLeave', userID)
            if (this.meetingUserIdList.length == 2) {
                this.$store.commit("updateCallStatus", "idle");
            }
            this.$store.commit("userLeaveMeeting", userID);
        },
        handleInviteeReject: async function ({ userID }) {
            console.log('handleInviteeReject')
            const userName = await getUsernameByUserid(userID);
            this.$message.warning(`拒绝通话`);
            this.$store.state.autioEle.pause();
            this.$store.state.autioEle.remove()
            this.$store.commit("updataBtnText", '点击核验');
            this.$store.commit("updataBtnFlag", false);
            this.dissolveMeetingIfNeed();
        },
        handleInviteeLineBusy: async function ({ userID }) {
            console.log('handleInviteeLineBusy')
            const userName = await getUsernameByUserid(userID);
            this.$message.warning(`忙线中请稍后拨打`);
            this.$store.commit("updataBtnText", '点击核验');
            this.$store.commit("updataBtnFlag", false);
            this.$trtcCalling.hangup();
            this.dissolveMeetingIfNeed();
            // this.$router.push("/");
            this.$store.commit("userAccepted", false);
        },
        handleInviterCancel: function () {
            console.log('handleInviterCancel')
            // 邀请被取消
            this.isShowNewInvitationDialog = false;
            this.$message.warning("通话已取消");
            this.$store.commit("updataBtnText", '点击核验');
            this.$store.commit("updataBtnFlag", false);
            this.dissolveMeetingIfNeed();
        },
        handleKickedOut: function () {
            console.log('handleKickedOut')
            //重复登陆，被踢出房间
            this.$store.commit("userAccepted", false);
            this.$trtcCalling.logout();
            this.$store.commit("userLogoutSuccess");
            this.$message({
                message: `重复登录或请关闭重复页面`,
                type: "warning",
            });
            console.log(2222222, '重复登录')
        },
        // 作为被邀请方会收到，收到该回调说明本次通话超时未应答
        handleCallTimeout: function () {
            console.log('handleCallTimeout')
            this.isShowNewInvitationDialog = false;
            this.errMseeageFlg = true
            this.$message.warning("对方无应答");
            this.$store.state.autioEle.pause();
            this.$store.state.autioEle.remove()
            this.dissolveMeetingIfNeed();
            this.$store.commit("updataBtnText", '点击核验');
            this.$store.commit("updataBtnFlag", false);
        },
        loginout () {
            let promise = this.$trtcCalling.logout()
            promise.then(() => {

            }).catch(error => {
                console.log('退出登录')
            })
        },
        handleCallEnd: function (e) {
            console.log(e)
            console.log(666666666666)
            if (this.isShowNewInvitationDialog) {
                this.$message.success("通话已结束");
            }

            if (e.callEnd != 0) {
                this.$store.commit("updatahangupStatus", false);
                this.$message({
                    message: '通话已结束',
                    type: "warning",
                });
            }
            this.loginout()
            this.$store.commit("userJoinMeetingList", "购机者");
            this.$trtcCalling.hangup();
            this.dissolveMeetingIfNeed();
            
            // this.$router.push("/");
            this.$store.commit("userAccepted", false);
        },
        handleNoResponse: async function ({ userID }) {
            console.log('handleNoResponse')
            const userName = await getUsernameByUserid(userID);
            this.$message.warning(`对方无应答`);
            // this.$store.state.autioEle.pause();
            // this.$store.state.autioEle.remove()
            this.dissolveMeetingIfNeed();
            this.$store.commit("updataBtnText", '点击核验');
            this.$store.commit("updataBtnFlag", false);
        },
        handleUserVideoChange: function ({ userID, isVideoAvailable }) {
            console.log('handleUserVideoChange')
            // log(
            //     `handleUserVideoChange userID, ${userID} isVideoAvailable ${isVideoAvailable}`
            // );
            if (isVideoAvailable) {
                const muteUserList = this.muteAudioUserIdList.filter(
                    (currentID) => currentID !== userID
                );
                this.$store.commit("updateMuteVideoUserIdList", muteUserList);
            } else {
                const muteUserList = this.muteAudioUserIdList.concat(userID);
                this.$store.commit("updateMuteVideoUserIdList", muteUserList);
            }
        },
        handleUserAudioChange: function ({ userID, isAudioAvailable }) {
            console.log('handleUserAudioChange')
            // log(
            //     `handleUserAudioChange userID, ${userID} isAudioAvailable ${isAudioAvailable}`
            // );
            if (isAudioAvailable) {
                const muteUserList = this.muteAudioUserIdList.filter(
                    (currentID) => currentID !== userID
                );
                this.$store.commit("updateMuteAudioUserIdList", muteUserList);
            } else {
                const muteUserList = this.muteAudioUserIdList.concat(userID);
                this.$store.commit("updateMuteAudioUserIdList", muteUserList);
            }
        },
        dissolveMeetingIfNeed () {
            console.log('dissolveMeetingIfNeed')
            this.$store.commit("updateCallStatus", "idle");
            this.$store.commit("updataBtnText", '点击核验');
            this.isShowNewInvitationDialog = false;
            if (this.meetingUserIdList.length < 2) {
                this.$store.commit("dissolveMeeting");
            }
        },
    },
};
</script>

<style>
html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
    background: url("./assets/beijing.png") no-repeat;
    background-size: 100% 100%;
}

.global-messageZindex {
    z-index: 3000 !important;
}

@media screen and (max-width: 767px) {
    .el-message {
        min-width: 180px;
    }
}
</style>
